
import moment from 'moment';
import ReactGA from 'react-ga';


const trackingId = "G-KVG9KWCG21";
ReactGA.initialize(trackingId);

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.pageview(window.location.pathname);
};
export function formatLeftTime(value) {
    if (!value) return ''
    return '残り'+value + '秒'
}

export function formateDate(time) {
    if (!time) return ''
    let date = new Date(time)
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()
  }

  
export function CalcMonths(fromDate,toDate) {
    return (toDate.getFullYear() - fromDate.getFullYear()) * 12 +(toDate.getMonth() - fromDate.getMonth())
}


export function AddMonths(date,months) {
    
    let orgDate = new Date(date);
    let orgEndDay = orgDate.getDate()
    let newDate = new Date(orgDate.getFullYear(), orgDate.getMonth()+ months, 1);
    const endOfMonth = getLastDayOfMonth(newDate)
    let orgNewDay = endOfMonth.getDate()
    if  (isEndOfMonth(orgDate)){
      return endOfMonth
    }else{
      if  (orgEndDay>=orgNewDay){
        return endOfMonth
      }else{
        return new Date(newDate.getFullYear(), newDate.getMonth(), orgEndDay);
      }
    }
}
export function isEndOfMonth(date) {
  const nextDay = date;
  nextDay.setDate(date.getDate() + 1);

  return nextDay.getMonth() !== date.getMonth();
}

export function getLastDayOfMonth(date) {
  const year = date.getFullYear();
  const month = date.getMonth();
  const nextMonthFirstDay = new Date(year, month + 1, 1);
  nextMonthFirstDay.setDate(0);
  return nextMonthFirstDay;
}

export function GetPreviousMonth(dateString) {
  let dateObject = moment(dateString, 'YYYY-MM-DD').toDate();
  
  if  (isEndOfMonth(dateObject)){
    dateObject = dateObject.setDate(1);
    return dateObject.setMonth(dateObject.getMonth()-1);
  }
  let year = dateObject.getFullYear();
  let month = dateObject.getMonth();
  let day = dateObject.getDate();

  if (month === 0) {
    month = 11;
    year -= 1;
  } else {
    month -= 1;    
  }

  return new Date(year, month, day);
}

export function DateTimeToString(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return  `${year}-${month}-${day}`;
}
export function DateTimeToString1(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return  `${year}${month}${day}`;
}

export function leftChar(str){  
  const index = str.indexOf('(');
  return (index !== -1 ? str.substring(0, index) : str);
}
export function middleChar(str){  
  const startIndex = str.indexOf('(');
  const endIndex = str.indexOf(')');
  return (startIndex !== -1 && endIndex !== -1 ? str.substring(startIndex , endIndex+1) : str);
}
export function ToHalfWidthNumber(str){
  let num = str.replace(/[０-９]/g, ch => String.fromCharCode(ch.charCodeAt(0) - 0xFEE0));
  return Number(num.replace(/,/g, ''));
}
export function numFormat (num){
  if  (num==='None') return 'ー';
  if  (num==='-') return '-';
  let [n] = num.toString().split('.');
  return [n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')].join('.');
}
export function rateFixed (num,digit) {
  if  (num==='None') return 'ー';
  return (Number(num*100).toFixed(digit))
}

export function rateFixed1 (num,digit) {
  if  (num==='None') return 'ー';
  return (Number(num).toFixed(digit))
}
export function rateFormat (num) {
  if  (num==='None') return 'ー';
  if  (num==='-') return '-';
  return (Number(num).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'))
}

export function rateFormat1 (num) {
  if  (num==='None') return 'ー';
  return (Number(num).toFixed(1).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'))
}
export function removeTFromCode (code) {
  if (code.endsWith('.T')) {
    return code.slice(0, -2);
  }
  return code;
}


export function makeURL (item) {
  const url = item.url || '';
  const isin = item.isin || '';

  if (url !== '') {
    return url;
  } else {
    if (item.provider === 'yahoo') {
      return `https://finance.yahoo.com/quote/${item.code}/`;
    } else if (item.provider === 'stooq') {
      return `https://stooq.com/q/?s=${item.code}/`;
    } else {
      if (isin !== '') {
        return `https://toushin-lib.fwg.ne.jp/FdsWeb/FDST030000?isinCd=${isin}`;
      } else {
        return "";
      }
    }
  }
}

export function formatString(template, values) {
  return template.replace(/{}/g, () => values.shift()); // Replace each '{}' with the next value in the array
}

export function makeURL1 (item) {
  const url = item.URL || '';
  const isin = item.ISIN || '';
  const provider = item.Provider || '';
  const code = item.Code || '';

  if (url !== '') return url;

  if (provider === 'yahoo') {
    return `https://finance.yahoo.com/quote/${code}/`;
  }

  if (provider === 'stooq') {
    return `https://stooq.com/q/?s=${code}`;
  }

  if (provider === 'jpx') {
    return 'https://www.jpx.co.jp/markets/statistics-equities/daily/index.html';
  }

  if (isin !== '') {
    return `https://toushin-lib.fwg.ne.jp/FdsWeb/FDST030000?isinCd=${isin}`;
  }

  if (/^JP[A-Z0-9]{10}$/.test(code)) {
    return `https://toushin-lib.fwg.ne.jp/FdsWeb/FDST030000?isinCd=${code}`;
  }

  return '';
}

export function hexToRgb(hex) {
  hex = hex.replace('#', '');

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgb(${r}, ${g}, ${b})`;
}


export function hexToRgba(hex) {
  hex = hex.replace('#', '');

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgb(${r}, ${g}, ${b}, 0)`;
}

